/*eslint-disable */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import VisibilitySensor from 'react-visibility-sensor';

// Multibrand-UI Components
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Link from '@zg-rentals/multibrand-ui/lib/Link';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Input from '@zg-rentals/multibrand-ui/lib/Input';
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import Checkbox from '@zg-rentals/multibrand-ui/lib/Checkbox';

// TODO: update mui Row, Col to use zrs-comet
import { Container } from '@zillow/zrs-comet';

import { Link as v4Link } from 'react-router-dom';

// rmw context
import { RMWContext } from 'app/shared/providers/RMWContext';

// Actions
import LeadActions from 'app/shared/actions/LeadActions';

// page containers
import AuthCheckWrapper from 'app/shared/containers/AuthCheckWrapper';

import HeadWrapper from 'app/shared/components/HeadWrapper';
import QueryUtils from 'app/shared/utils/queryUtils';
import sharedConfig from 'app/shared/sharedConfig';
import PDPContentSkeleton from 'app/shared/components/skeletons/PDPContentSkeleton';

import LeadForListingItem from 'app/shared/components/leadsForListing/LeadForListingItem';
// Selectors
import { LeadSelectors, UserSelectors, EnvSelectors } from 'app/shared/selectors';

import pathsManifest from 'app/shared/pathsManifest';

//utils
import userUtils from 'app/shared/utils/userUtils';

// Stylesheets
import './style.scss';

const SATELLITE_INQUIRER_TYPE = 'zillowGroupRentalsUnifiedEmail';

const paths = pathsManifest.getAllPaths();

const propTypes = {
    match: PropTypes.object.isRequired
};

// Trying to get all historical leads data,
// so start date of 01/01/2000 in YYYYMMDD
const LEADS_EXCEL_START_DATE = 20000101;
const LEADS_EXCEL_LIMIT = 10000;

class LeadsForListingPage extends React.Component {
    static contextType = RMWContext;

    constructor(props) {
        super(props);

        this.state = this.getInitialState();

        // bind methods
        this.fetchLeadsForListing = this.fetchLeadsForListing.bind(this);
        this.renderLoadComplete = this.renderLoadComplete.bind(this);
        this.renderInfiniteScrollSection = this.renderInfiniteScrollSection.bind(this);
        this.handleSeeMore = this.handleSeeMore.bind(this);
        this.handleLeadClick = this.handleLeadClick.bind(this);
        this.handleDownloadClick = this.handleDownloadClick.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.handleAddFakeLead = this.handleAddFakeLead.bind(this);
        this.handleContactNameChange = this.handleContactNameChange.bind(this);
        this.handleContactEmailChange = this.handleContactEmailChange.bind(this);
        this.handleIsPhoneLeadChange = this.handleIsPhoneLeadChange.bind(this);
        this.handleMessageChange = this.handleMessageChange.bind(this);
    }

    getInitialState() {
        return {
            isLoading: true, // is page loading
            hasAccess: false,
            listingId: this.props.match.params.propertyId, // endpoint for stats is listingId,
            hideSeeMore: false,
            failedToloadLeads: false,
            showLoadingSkeleton: false,
            isPhoneLead: false,
        };
    }

    componentDidMount() {
        const { listingId } = this.state;

        if (listingId) {
            const endpointParams = {
                listingId,
            };

            this.fetchLeadsForListing(endpointParams).then(() => {
                this.setState({ isLoading: false });
            });
        }
    }

    fetchLeadsForListing(endpointParams, appendToInquiries = false) {
        const { dispatch } = this.props;

        return dispatch(LeadActions.getLeadsForListing(endpointParams, appendToInquiries)).then(
            function (result) {
                if (result.payload.success === false) {
                    if (result.payload.error.message.toLowerCase().indexOf('access denied') > -1) {
                        this.setState({ hasAccess: false });
                    }

                    throw new Error(result.payload.error.message);
                } else {
                    this.setState({ hasAccess: true });
                }
            }.bind(this)
        );
    }
    /*
        * handleSeeMore fetches more leads with max-retries (set to 2) in case of failure
    */
    handleSeeMore(retriesCounter = 0) {
        const { leadsForListing } = this.props;
        const { listing, pager } = leadsForListing;
        const { feedListingId, feedId } = listing;
        const { limit } = pager;
        const listingId = feedListingId + '_' + feedId;
        const MAX_RETRIES = 2;
        // if on last page
        if (pager.nextPage === 0) {
            return;
        }

        if (retriesCounter === 0) {
            this.setState({ showLoadingSkeleton: true });
        }

        const start = (pager.nextPage - 1) * pager.limit;

        const endpointParams = {
            listingId,
            start,
            limit
        };

        this.setState({
            hideSeeMore: true
        });

        this.fetchLeadsForListing(endpointParams, true)
            .then(() => {
                this.setState({
                    failedToloadLeads: false,
                    showLoadingSkeleton: false
                });
            })
            .catch((err) => {
                //if failed to fetch data, retry MAX_RETRIES times
                if (retriesCounter < MAX_RETRIES) {
                    this.handleSeeMore(retriesCounter + 1);
                } else {
                    // check error and use info to determine whether or not to show skeleton or "sorry" text
                    this.setState({
                        failedToloadLeads: true,
                        showLoadingSkeleton: false
                    });
                }
            });
    }

    handleLeadClick(leadData) {
        const { dispatch, user } = this.props;
        const { roles } = user;
        const { listingId } = this.state;
        const { inquirerType, id } = leadData;
        const shouldGoToSatellite = inquirerType === SATELLITE_INQUIRER_TYPE;
        const isPostingPathAdmin = userUtils.isPostingPathAdmin(roles);

        if (!isPostingPathAdmin) {
            dispatch(LeadActions.updateLeadStatus({ leadId: id, read: true }));
        }

        if (shouldGoToSatellite) {
            window.router.updateLocation(`${paths.base}/inbox/${listingId}/${id}`);
        } else {
            const leadUrl = `${paths.leadPage}/${id}`;
            window.router.transitionTo(leadUrl);
        }
    }

    handleDownloadClick() {
        const { listingId } = this.state;

        const excelPath = paths.exportExcel.leads;
        const excelParams = QueryUtils.stringify({
            listingId,
            limit: LEADS_EXCEL_LIMIT,
            startDateYyyyMmDd: LEADS_EXCEL_START_DATE
        });

        const excelUrl = `${paths.proxy}/${sharedConfig.baseApi}${excelPath}${excelParams}`;

        window.open(excelUrl);
    }

    handleScroll(isVisible) {
        isVisible && this.handleSeeMore();
    }

    renderInfiniteScrollSection() {
        const { failedToloadLeads, showLoadingSkeleton } = this.state;
        const { leadsForListing } = this.props;
        const { nextPage } = leadsForListing.pager;

        if (failedToloadLeads) {
            return (
                <Text>We had trouble fetching new leads, please refresh or try again later</Text>
            );
        } else if (nextPage !== 0 && showLoadingSkeleton) {
            return (
                <PDPContentSkeleton />
            );
        }
    }

    handleAddFakeLead() {
        const { listingId, contactName, contactEmail, message, isPhoneLead } = this.state;
        const { dispatch } = this.props;
        const endpointParams = {
            listingId,
            contactName,
            contactEmail,
            message,
            isPhoneLead,
        };
        dispatch(LeadActions.createFakeLeadForListing(endpointParams))
            .then(() => this.fetchLeadsForListing(endpointParams))
            .then(() => this.clearFormFields())
            .catch((err) => {
                global.TEMPORARY_global_logger.error(err);
            })
    }

    clearFormFields() {
        this.setState({
            contactName: "",
            contactEmail: "",
            message: "",
        });
    }

    handleContactNameChange(e) {
        this.setState({ contactName: e.target.value })
    }

    handleContactEmailChange(e) {
        this.setState({ contactEmail: e.target.value })
    }

    handleIsPhoneLeadChange() {
        this.setState({ isPhoneLead: !this.state.isPhoneLead })
    }

    handleMessageChange(e) {
        this.setState({ message: e.target.value })
    }

    renderLoadComplete() {
        const { contactName, contactEmail, message, isPhoneLead } = this.state;
        const { leadsForListing, user, isProduction } = this.props;
        const { inquiries } = leadsForListing;
        const isCommunity = leadsForListing.listing.isCommunity;

        if (this.state.hasAccess) {
            return (
                <Container
                    fluid={true}
                    className="LeadsForListingPage-Container"
                >
                    {inquiries.length > 0 ? (
                        <React.Fragment>
                            <Row noMargin={true}>
                                <Col>
                                    <div className="LeadsForListingPage-Header-Container">
                                        {isCommunity && (
                                            <Link
                                                reactRouterLink={v4Link}
                                                type="secondary"
                                                className="LeadsForListingPage-Header-link"
                                                onClick={this.handleDownloadClick}
                                            >
                                                Download Leads
                                            </Link>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    {inquiries.map((inquiry, key) => {
                                        return (
                                            <React.Fragment key={key}>
                                                <LeadForListingItem
                                                    leadData={inquiry}
                                                    isMultifamily={leadsForListing.listing.isMultifamily}
                                                    permanent={leadsForListing.listing.permanent}
                                                    isFirstInList={key === 0}
                                                    // handlers
                                                    handleLeadClick={this.handleLeadClick}
                                                />
                                                {key % 15 === 0 &&
                                                    key !== 0 && <VisibilitySensor onChange={this.handleScroll} />}
                                            </React.Fragment>
                                        );
                                    })}
                                </Col>
                            </Row>
                            <Row>
                                <div className="LeadsForListingPage-Pagination-Container">
                                    {this.renderInfiniteScrollSection()}
                                </div>
                            </Row>
                        </React.Fragment>
                    ) : (
                        <Text className="LeadsForListingPage-no-listings">
                            There were no leads found for this listing.
                        </Text>
                    )}
                    { !isProduction && (
                        <Container className="NewLeadInfo">
                            <Text className="LeadsForListingPage-AddNewLead-module-title" type="h2">
                                Add New Lead
                            </Text>
                            <Row noPadding={true}>
                                <Col
                                    md={6}
                                    className="AddNewLead-Col-odd"
                                >
                                    <Input
                                        className="LeadsForListingPage-AddNewLead-Col-odd"
                                        label="Name"
                                        name="contactName"
                                        value={contactName}
                                        placeholder="Your name here"
                                        onChange={this.handleContactNameChange}
                                    />
                                    <Input
                                        className="LeadsForListingPage-AddNewLead-Col-odd"
                                        label="Email"
                                        name="contactEmail"
                                        value={contactEmail}
                                        placeholder="Email"
                                        onChange={this.handleContactEmailChange}
                                    />
                                    <Input
                                        className="LeadsForListingPage-AddNewLead-Col-odd"
                                        label="Message"
                                        name="message"
                                        value={message}
                                        placeholder="Message"
                                        onChange={this.handleMessageChange}
                                    />
                                    <Checkbox
                                        className="LeadsForListingPage-AddNewLead-Col-odd"
                                        label="Is Phone Lead?"
                                        name="isPhoneLead"
                                        checked={isPhoneLead}
                                        onChange={this.handleIsPhoneLeadChange}
                                    />
                                    <Button
                                        className="LeadsForListingPage-AddNewLead-Col-odd"
                                        type="primary"
                                        onClick={this.handleAddFakeLead}
                                    >
                                        Submit
                                    </Button>
                                </Col>
                            </Row>
                        </Container>
                    )}
                </Container>
            );
        } else {
            return (
                <div className="LeadsForListingPage-Container">
                    <Text type="h1" className="LeadsForListingPage-no-access">
                        This listing does not belong to your account.
                    </Text>
                </div>
            );
        }
    }

    render() {
        const { leadsForListing } = this.props;
        const listingName = leadsForListing.listing.street;
        const titleContent = listingName ? `Leads for ${listingName}` : 'Leads';

        return (
            <AuthCheckWrapper requireStrongAuthentication={false}>
                <div className="LeadsForListingPage">
                    <HeadWrapper title={titleContent} />
                    {this.state.isLoading ? <PDPContentSkeleton /> : this.renderLoadComplete()}
                </div>
            </AuthCheckWrapper>
        );
    }
}

const mapStateToProps = (state) => ({
    leadsForListing: LeadSelectors.makeLeadsForListing(state),
    user: UserSelectors.makeUser(state),
    isProduction: EnvSelectors.makeIsProduction(state)
});

LeadsForListingPage.propTypes = propTypes;

export { LeadsForListingPage };
export default connect(mapStateToProps)(LeadsForListingPage);
/* eslint-enable */
